import type { TOC } from '@ember/component/template-only';
import TioRouteError from 'tio-common/components/tio/route-error';
import { t } from 'ember-intl';

interface ErrorRouteSignature {
  Args: {
    model: unknown;
  };
}

const AuthenticatedErrorRoute: TOC<ErrorRouteSignature> = <template>
  <TioRouteError
    @error={{@model}}
    @title={{t "route_error.title"}}
    @description={{t "route_error.description"}}
    @retryLabel={{t "route_error.retry"}}
    @homeLabel={{t "route_error.go_home"}}
  />
</template>;

export default AuthenticatedErrorRoute;
